var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"text-no-wrap"},[_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.name))])]),_c('td',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }